<template>
  <ms-dialog
    ref="dialog"
    :append-to-body="false"
    :width="dialogWidth"
    :title="$t('User.ChangePassword')"
    @close="onCloseProxy"
  >
    <div
      class="container"
      ref="container"
    >
      <ms-form
        class="forget-password-form"
        @keyup.enter="onChangePassword"
      >
        <!-- Nhập mật khẩu -->
        <div class="row">
          <ms-text-field
            ref="oldPassword"
            :placeholder="$t('User.EnterCurrentPassword')"
            v-model="currentItem.password"
            show-password
            :allow-blank="false"
            @blur="onBlurPassword"
          >
            <template #prefix>
              <div class="input-prefix-icon">
                <img
                  :src="iconPassword?.src"
                  :width="iconPassword?.width"
                  :height="iconPassword?.height"
                >
              </div>
            </template>
          </ms-text-field>
        </div>
        <!-- Nhập mật khẩu mới -->
        <div class="row">
          <ms-text-field
            ref="newPassword"
            :placeholder="$t('User.EnterNewPassword')"
            v-model="currentItem.newPassword"
            @blur="onBlurNewPassword"
            show-password
          >
            <template #prefix>
              <div class="input-prefix-icon">
                <img
                  :src="iconPassword?.src"
                  :width="iconPassword?.width"
                  :height="iconPassword?.height"
                >
              </div>
            </template>
          </ms-text-field>
        </div>
        <!-- Trạng thái mật khẩu -->
        <div
          class="password-status"
          v-show="isShowStatusPassword"
        >
          <div :class="['text-align-left', passwordStatus?.minLength && 'valid']">
            {{ $t('User.EightCharacters') }}
          </div>
          <div :class="['text-align-center', passwordStatus?.hasUpperAndLower && 'valid']">
            {{ $t('User.UpperAndLowerLetter') }}
          </div>
          <div :class="['text-align-right', passwordStatus?.hasDigit && 'valid']">
            {{ $t('User.HasDigit') }}
          </div>
        </div>
        <!-- Nhập lại mật khẩu -->
        <div class="row">
          <ms-text-field
            :placeholder="$t('User.ConfirmPassword')"
            v-model="currentItem.confirmPassword"
            @blur="onBlurPasswordConfirm"
            ref="confirmPassword"
            show-password
            :allow-blank="false"
          >
            <template #prefix>
              <div class="input-prefix-icon">
                <img
                  :src="iconPassword?.src"
                  :width="iconPassword?.width"
                  :height="iconPassword?.height"
                >
              </div>
            </template>
          </ms-text-field>
        </div>
        <!-- Button gửi yêu cầu -->
        <div class="row">
          <ms-button
            type="gradient"
            @click="onChangePassword"
          >
            {{ $t('User.ChangePassword') }}
          </ms-button>
        </div>
      </ms-form>
    </div>
  </ms-dialog>
</template>

<script>
import BaseDetailPopup from '@/views/base/base-detail-popup.vue'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { mapActions } from 'vuex'

export default {
  extends: BaseDetailPopup,

  data () {
    return {
      currentItem: {
        userName: getContextData(ContextDataKey.PhoneNumber),
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      dialogWidth: '400px',
      isShowStatusPassword: false,
      autoLoad: false,
      /**
       * icon mật khẩu
       */
      iconPassword: {
        src: require('@/assets/icons/svg/account/icon_key.svg'),
        width: 16,
        height: 16
      }
    }
  },

  computed: {
    /**
     * trạng thái của password: đủ 8 ký tự?, chứa số?, chứa chữ hoa và thường?
     */
    passwordStatus () {
      const password = this.currentItem.newPassword
      const regexNumber = /\d/
      const regexUpper = /[A-Z]/
      const regexLower = /[a-z]/
      const lengthMin = 8

      return {
        minLength: password?.length >= lengthMin,
        hasDigit: regexNumber.test(password),
        hasUpperAndLower: regexUpper.test(password) && regexLower.test(password)
      }
    }
  },

  methods: {
    ...mapActions('account', {
      changePassword: 'changePassword'
    }),

    getContainer () {
      return this.$refs.container
    },

    /**
     * @author PVThang
     * @description Gọi clearCustomError của tất cả các ref
     */
    clearCustomError () {
      const me = this
      const refs = me.$refs

      Object.keys(refs).forEach(key => {
        if (typeof (refs[key].clearCustomError) === 'function') {
          refs[key].clearCustomError()
        }
      })
    },

    /**
     * @author PVThang
     * @description
     */
    onCloseProxy () {
      const me = this

      this.currentItem = {
        userName: getContextData(ContextDataKey.PhoneNumber),
        password: '',
        newPassword: '',
        confirmPassword: ''
      }
      me.clearCustomError()
    },

    /**
     * @author PVThang
     * @description xử lý đổi mật khẩu
     */
    onChangePassword () {
      const me = this

      me.clearCustomError()
      me.showMask()
      if (!me.validateForm()) {
        setTimeout(() => {
          me.hideMask()
        }, me.$enumeration.TimeShowMask.Default)
        me.onAfterHandleError()
        return
      }

      me.changePassword(me.currentItem).then(res => {
        if (res?.Data?.Status?.Error) {
          me.onHandleError(res)
          me.onAfterHandleError()
        } else {
          me.$notify.showSuccess({
            message: me.$t('User.ChangePasswordSuccess')
          })
          me.doClose()
        }
      }).finally(() => {
        me.hideMask()
      })
    },

    /**
     * @author PVThang
     * @description validate dữ liệu
     */
    validateForm () {
      const me = this
      let result = true

      me.onBlurPassword()
      me.onBlurNewPassword()
      me.onBlurPasswordConfirm()

      Object.keys(me.$refs).forEach(key => {
        if (me.$refs[key]?.hasError) {
          result = false
        }
      })
      return result
    },

    /**
     * @author PVThang
     * @description Xử lý lỗi trả về từ server
     */
    onHandleError (res) {
      const me = this
      var errorCodes = res?.Data?.Status?.ErrorCode
      const errorCodeMisaID = me.$enumeration?.ErrorCodeMisaID

      if (!Array.isArray(errorCodes)) {
        errorCodes = [errorCodes]
      }

      if (errorCodes.includes(errorCodeMisaID?.CurentPasswordInvalid)) {
        me.$refs.oldPassword.setCustomError(me.$t('User.PasswordInvalid'))
      }
    },

    /**
     * @author PVThang
     * @description Xử lý sau khi có lỗi
     */
    onAfterHandleError () {
      const me = this
      const keys = Object.keys(me.$refs)

      for (let i = 0; i < keys.length; ++i) {
        if (me.$refs[keys[i]].hasError && typeof (me.$refs[keys[i]].focus) === 'function') {
          me.$refs[keys[i]].focus()
          break
        }
      }
    },

    /**
     * @author PVThang
     * @description xử lý sự kiện blur password
     */
    onBlurPassword () {
      const me = this

      me.$refs.oldPassword.clearCustomError()
      if (!me.currentItem?.password) {
        me.$refs.oldPassword.setCustomError(me.$t('User.NotAllowBlank'))
      }
    },

    /**
     * @author PVThang
     * @description xử lý sự kiện blur new password
     */
    onBlurNewPassword () {
      const me = this

      me.$refs.newPassword.clearCustomError()
      if (!(me.passwordStatus?.minLength && me.passwordStatus?.hasUpperAndLower && me.passwordStatus?.hasDigit)) {
        me.$refs.newPassword.setCustomError('')
      }
      if (me.currentItem?.newPassword === me.currentItem?.confirmPassword) {
        me.$refs.confirmPassword.clearCustomError()
      }
      me.isShowStatusPassword = true
    },

    /**
     * @author PVThang
     * @description xử lý sự kiện blur password-confirm
     */
    onBlurPasswordConfirm () {
      const me = this

      me.$refs.confirmPassword.clearCustomError()
      if (!me.currentItem?.confirmPassword) {
        me.$refs.confirmPassword.setCustomError(me.$t('User.NotAllowBlank'))
      } else if (me.currentItem?.newPassword !== me.currentItem?.confirmPassword) {
        me.$refs.confirmPassword.setCustomError(me.$t('User.PasswordConfirmNotDuplicate'))
      }
    }
  }

}
</script>

<style lang="scss" scoped>

.forget-password-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;

  .ms-button {
    margin: 0;
  }

  .row {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    width: 100%;

    > * {
        width: 100%;
    }

    .text-accent {
      width: auto;
      margin-top: 24px;
      color: $color-semantic-blue;
      cursor: pointer;
    }
  }

  .password-status {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-column-gap: 4px;
    padding-top: 4px;

    > div {
      padding-top: 4px;
      @include caption();
      border-top: 2px solid $color-error;
      color: $color-error;
    }

    .valid {
      border-top: 2px solid $color-success;
      color: $color-success;
    }
  }

  .text-align-left {
    text-align: left;
  }

  .text-align-center {
    text-align: center;
  }

  .text-align-right {
    text-align: right;
  }

  .input-prefix-icon {
    width: 28px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
